import { Color, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${zIndex.FullScreenOverlay};
  background-color: ${Color.White};
  overflow-y: auto;
`
